import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import Tab from "../components/generic/Tab";
import ManageMaterialsPropertyForm from "../components/materials/ManageMaterialsPropertyForm";
import AddInventory from "../components/inventory/AddInventory";
import UpdateInventory from "../components/inventory/UpdateInventory";
import FormComponent from "../components/generic/FormComponent";

export const MANAGE_MATERIAL_TABS = [
    { label: "Manage Materials", endpoint: "manage" },
    { label: "Add Materials", endpoint: "add" },
    { label: "Use Materials", endpoint: "use" },
];

interface MaterialsPageProps {
    activeTab?: number;
}

const MaterialsPage: React.FC<MaterialsPageProps> = ({ activeTab = 0 }) => {
    const [ activeTabState, setActiveTab ] = useState<number>(activeTab);
    const navigate = useNavigate();
    const location = useLocation();

    // Handle tab change
    const handleTabChange = (label: string) => {
        const newActiveTab = MANAGE_MATERIAL_TABS.findIndex((tab) => tab.label === label);
        if (newActiveTab !== -1) {
            setActiveTab(newActiveTab);
            navigate(`/materials/${MANAGE_MATERIAL_TABS[newActiveTab].endpoint}`);
        }
    };

    useEffect(() => {
        setActiveTab(activeTab);
    }, [ activeTab ]);

    useEffect(() => {
        const currentTab = MANAGE_MATERIAL_TABS.findIndex(tab => location.pathname.includes(tab.endpoint));
        if (currentTab !== -1) {
            setActiveTab(currentTab);
        }
    }, [ location.pathname ]);

    return (
        <div>
            {/* Tab Navigation */}
            <div>
                <Tab
                    tabs={MANAGE_MATERIAL_TABS.map(tab => tab.label)} // Pass tab labels to the Tab component
                    activeTab={MANAGE_MATERIAL_TABS[activeTabState].label} // Highlight the active tab
                    onTabChange={handleTabChange} // Handle tab switching
                />
                {/* Tab Content */}
                {activeTabState === 0 && <ManageMaterialsPropertyForm/>}
                {activeTabState === 1 && <AddInventory/>}
                {activeTabState === 2 && <UpdateInventory/>}
            </div>
        </div>
    );
};

export default MaterialsPage;